<script lang="ts">import { cfgCdnBanners, FeatureSet, stateFeatureSet } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isSpecialWidthCase } from "@infinitro/global";
import { Text } from "@infinitro/text";
import "../api/api";
export let race;
export let raceId = undefined;
const BANNERS_CDN = cfgCdnBanners();
const BANNERS_BASE = $stateFeatureSet === FeatureSet.Preview ? `${BANNERS_CDN}staging/` : `${BANNERS_CDN}`;
$: id = "races";
</script>

<div class="races-banner-wrapper">
	{#if $isMobile}
		<div class="banner-content-text-mobile">
			<div class="top-banner-text-mobile">
				<div class="weekly-races-text-mobile">
					{#each $t(Verbiage.weekly_races).split(' ') as word, index}
						<div class:weekly-races-text-second-part-mobile={index === 1}>
							<Text
								type="title"
								titleWeight="bold"
								customStyle="font-weight: 900 !important; font-size: 1.375rem !important; {index ===
								0
									? 'color: #FFCE2B !important;'
									: ''}"
							>
								{word}
							</Text>
						</div>
					{/each}
				</div>
			</div>
			<div class="bottom-banner-text-mobile">
				<div class="description-text-mobile">
					<Text
						type="body"
						customStyle="font-size: 1.125rem !important; line-height: 120% !important; letter-spacing: -2% !important;"
					>
						{$t(Verbiage.races_banner_description)}
					</Text>
				</div>
			</div>
		</div>
		<img
			src={`${BANNERS_BASE}${id}/${id}.png`}
			alt={$t(Verbiage.races_banner_mobile_alt)}
			class="races-image-mobile"
		/>
	{:else}
		<div
			class:banner-content-text={!$isSpecialWidthCase}
			class:banner-content-text-special={$isSpecialWidthCase}
		>
			<div class="top-banner-text">
				<div class="weekly-races-text">
					{#each $t(Verbiage.weekly_races).split(' ') as word, index}
						<div class:weekly-races-text-second-part={index === 1}>
							<Text
								type="title"
								titleWeight="bold"
								customStyle="font-weight: 900 !important; font-size: 2.5rem !important; {index === 0
									? 'color: #FFCE2B !important;'
									: ''}"
							>
								{word}
							</Text>
						</div>
					{/each}
				</div>
			</div>
			<div class="bottom-banner-text">
				<div class="description-text">
					<Text
						type="body"
						customStyle="font-size: 1.5rem !important; line-height: 120% !important; letter-spacing: -2% !important;"
					>
						{$t(Verbiage.races_banner_description)}
					</Text>
				</div>
			</div>
		</div>
		<img
			src={`${BANNERS_BASE}${id}/${id}-detail.png`}
			alt={$t(Verbiage.races_banner_alt)}
			class="races-image"
		/>
	{/if}
</div>

<style>
	.races-image,
	.races-image-mobile {

    height: auto;

    width: 100%;

    border-radius: 16px
}

	.banner-content-text,
	.banner-content-text-mobile,
	.banner-content-text-special {

    position: absolute
}

	.banner-content-text {

    top: 2rem;

    left: 1.5rem;

    line-height: 1
}

	.banner-content-text-special {

    top: 0px;

    left: 1.25rem;

    line-height: 1
}

	.banner-content-text-mobile {

    top: 1rem;

    left: 1rem;

    line-height: 1
}

	.description-text-mobile {

    width: 65%;

    text-align: left
}

	.description-text {

    width: 60%;

    text-align: left
}

	.weekly-races-text,
	.weekly-races-text-mobile {

    text-transform: uppercase
}

	.weekly-races-text-second-part {

    margin-top: -1.5rem
}

	.weekly-races-text-second-part-mobile {

    margin-top: -2.5rem
}

	.races-banner-wrapper {

    width: 100%;

    overflow: hidden
}
</style>
